module.exports = __webpack_public_path__ + "static/img/13.56864a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/13.png
// module id = sSzJ
// module chunks = 0